var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Success from "@irati/ui/src/Success";
import DragAndDrop from "@irati/ui/src/DragAndDrop";
import { H2, H4 } from "@irati/ui/src/Headings";
import Flex from "@irati/ui/src/Flex";
import authentication from "@irati/auth";
import { injectIntl } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import { Para } from "@irati/ui/src/Labels";
import addUsersToTeamByCSV from "@irati/utils/addUsersToTeamByCSV";
var BulkAddUsersToTeam = /** @class */ (function (_super) {
    __extends(BulkAddUsersToTeam, _super);
    function BulkAddUsersToTeam() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null,
            saved: false,
            failedUsers: [],
            show: false
        };
        _this.handleBulkUsers = function (acceptedFiles) {
            var _a = _this.props, team = _a.team, formatMessage = _a.formatMessage;
            _this.setState({
                failedUsers: [],
                saved: false
            });
            var load = addUsersToTeamByCSV(acceptedFiles[0], formatMessage, authentication.userTenant().uuid, team.uuid).then(function (_a) {
                var failedUsers = _a.failedUsers, saved = _a.saved;
                if (_this.props.onSubmit)
                    _this.props.onSubmit();
                _this.setState({
                    failedUsers: failedUsers,
                    saved: saved
                });
            });
            _this.setState({ load: load });
        };
        return _this;
    }
    BulkAddUsersToTeam.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var _a = this.state, load = _a.load, saved = _a.saved, failedUsers = _a.failedUsers;
        if (saved && failedUsers.length === 0) {
            return (React.createElement(Success, null));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, { alignItems: "center", justifyContent: "center", direction: "column", margin: "0 0 30px" },
                React.createElement(H2, { tiny: true }, formatMessage({ id: "admin.components.bulkAddUsersToTeam.title" })),
                React.createElement(H4, { base: true }, formatMessage({ id: "admin.components.bulkAddUsersToTeam.para" })),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 12 },
                        React.createElement(DragAndDrop, { onDrop: this.handleBulkUsers })))),
            React.createElement(Loading, { load: load },
                React.createElement(Row, null,
                    React.createElement(Col, { md: 8, mdOffset: 2 },
                        saved && React.createElement(Para, { large: true }, formatMessage({ id: "admin.components.bulkAddUsersToTeam.partSuccess" })),
                        failedUsers.length > 0 && (React.createElement(React.Fragment, null,
                            React.createElement(Para, { large: true }, formatMessage({ id: "admin.components.bulkAddUsersToTeam.error" })),
                            failedUsers.map(function (_a) {
                                var email = _a.email, message = _a.message;
                                return (React.createElement(Para, null,
                                    email,
                                    ": ",
                                    message));
                            }))))))));
    };
    return BulkAddUsersToTeam;
}(Component));
export default injectIntl(BulkAddUsersToTeam);
